<template>
	<div class="common-box">
		<el-form
			inline
			ref="form"
			class="search-form common-box-search-form"
			label-position="right"
			:model="form"
			label-width="90px"
		>
			<search-form @search="handleSearch" @refresh="handleRefresh">
				<div slot="content">
					<el-form-item label="使用单位：">
						<el-select
							size="mini"
							v-model="form.propertyUnitId"
							filterable
							placeholder="请选择所属单位"
							clearable
							reserve-keyword
							:remote="true"
							@change="handleSearchListData"
							:remote-method="searchUnitList"
							@visible-change="searchUnitList('')"
						>
							<el-option
								v-for="item in unitList"
								:key="item.id"
								:label="item.unitName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属项目：">
						<el-select
							size="mini"
							v-model="form.projectId"
							filterable
							placeholder="请选择所属项目"
							clearable
							reserve-keyword
							:remote="true"
							@change="handleSearchListData"
							:remote-method="searchProjectList"
							@visible-change="searchProjectList('')"
						>
							<el-option
								v-for="item in projectList"
								:key="item.id"
								:label="item.projectName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="使用编号：">
						<el-input
							@change="handleSearchListData"
							size="mini"
							v-model.trim="form.useCertificateNumber"
							placeholder="请输入使用编号"
							clearable
						></el-input>
					</el-form-item>
					<AddreassSelect
						:isSearch="false"
						:warning="addressWarn"
						:showDetailAddress="showDetailAddress"
						:addressName="addressName"
						class="input-with-col2"
						@change="setPojectAddress"
					></AddreassSelect>
					<el-form-item label="电梯位置：">
						<el-input
							@change="handleSearchListData"
							size="mini"
							v-model.trim="form.liftLocation"
							placeholder="请输入电梯位置"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item label="所属部门：">
						<el-cascader
							placeholder="请选择所属部门"
							:options="departmentTree"
							:props="propsTree"
							filterable
							@change="handleDepartment"
							ref="cascader"
							collapse-tags
							v-model="departmentIdList"
						></el-cascader>
					</el-form-item>
					<el-form-item label="工单编号：">
						<el-input
							@change="handleSearchListData"
							size="mini"
							v-model.trim="form.orderNo"
							placeholder="请输入工单编号"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item label="添加时间：">
						<el-date-picker
							v-model="form.createTimeBetween"
							size="mini"
							type="daterange"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							value-format="yyyy-MM-dd"
							unlink-panels
							clearable
						></el-date-picker>
					</el-form-item>
				</div>
			</search-form>
		</el-form>
		<div class="common-cover-div"></div>
		<div class="operation-and-table__container">
			<div class="btns__container">
			</div>
			<div class="table__container">
				<el-table
					v-loading="tableLoading"
					:data="list"
					height="100%"
					border
					style="width: 100%"
					@selection-change="handleSelectionChange"
				>
					<el-table-column type="expand">
						<template slot-scope="props">
							<el-table
								:data="props.row.subOrderDTOList"
								height="100%"
								border
								style="width: 100%"
							>
								<el-table-column
									show-overflow-tooltip
									prop=""
									label=""
									width="50"
								></el-table-column>
								<el-table-column
									show-overflow-tooltip
									prop="orderNo"
									label="子工单编号"
									width="300"
								></el-table-column>

								<el-table-column
									show-overflow-tooltip
									prop="orderTypeName"
									label="工单类型"
									width="160"
								></el-table-column>
								<el-table-column
									show-overflow-tooltip
									prop="operatorUserName"
									label="执行人"
									width="160"
								></el-table-column>
								<el-table-column
									show-overflow-tooltip
									prop="dayAmount"
									label="天数"
									width="200"
								></el-table-column>

								<el-table-column
									show-overflow-tooltip
									prop="startTime"
									label="开始时间"
									width="200"
								></el-table-column>
								<el-table-column
									show-overflow-tooltip
									prop="endTime"
									label="完成时间"
									width="200"
								></el-table-column>
								<el-table-column
									show-overflow-tooltip
									prop="elapsedTime"
									label="耗时/秒"
									width="90"
								></el-table-column>

								<el-table-column
									show-overflow-tooltip
									prop="statusName"
									label="状态"
									width="100"
								>
								</el-table-column>

								<el-table-column label=" " prop=" "></el-table-column>
								<el-table-column label="操作" width="98px" fixed="right">
									<template slot-scope="scope">
										<el-button
											size="mini"
											type="text"
											v-if="!scope.row.operatorUserId && hasRole['NJGDZP']"
											@click="handleZP(scope.row)"
											>指派</el-button
										>
										<div
											class="btn-divide"
											v-if="!scope.row.operatorUserId"
										></div>
										<el-button
											size="mini"
											type="text"
											v-if="hasRole['NJGDXQ']"
											@click="handleCheck(scope.row)"
											>详情</el-button
										>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="orderNo"
						label="工单编号"
						width="300"
					></el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="projectName"
						label="项目名称"
						width="160"
					></el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="projectName"
						label="使用单位"
						width="160"
					></el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="liftLocation"
						label="电梯位置"
						width="200"
					></el-table-column>

					<el-table-column
						show-overflow-tooltip
						prop="startTime"
						label="开始时间"
						width="200"
					></el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="endTime"
						label="完成时间"
						width="200"
					></el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="elapsedTime"
						label="耗时/秒"
						width="90"
					></el-table-column>

					<el-table-column
						show-overflow-tooltip
						prop="statusName"
						label="状态"
						width="100"
					>
					</el-table-column>

					<el-table-column label=" " prop=" "></el-table-column>
					<el-table-column label="操作" width="98px" fixed="right">
						<template slot-scope="scope">
							<el-button
								size="mini"
								type="text"
								v-if="hasRole['NJGDSC']"
								@click="handleDeleteUnit(scope.row)"
								>删除</el-button
							>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagenation__container">
				<div class="for-fff-bg">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pageIndex"
						:page-sizes="[25, 50, 100, 150, 200]"
						:page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</div>
		</div>
		<check-order
			v-if="checkOrder"
			:editData="orderDetail"
			@cancel="checkOrder = false"
		></check-order>
		<check-order2
			v-if="checkOrder2"
			:editData="orderDetail"
			@cancel="checkOrder2 = false"
		></check-order2>
		<designate
			v-if="showDesignate"
			@cancel="showDesignate = false"
			:designateRow="designateRow"
			@confirm="designateConfirm"
		></designate>
	</div>
</template>

<script>
import { getDepartmentTree } from "@/api/ElevatorManagement";
import {
	getOrderList,
	deleteOrder,
	getProjectSimpleList,
	getPropertyUnitSimpleList,
} from "@/api/AnnualInspection";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import Designate from "./components/Designate";
import CheckOrder from "./components/CheckOrder";
import CheckOrder2 from "./components2/CheckOrder";
import { mapState } from "vuex";
export default {
	name: "AnnualInspection",
	components: {
		CheckOrder,
		AddreassSelect,
		Designate,
		CheckOrder2,
	},
	data() {
		return {
			form: {
				departmentIdList: [],
				propertyUnitId: "",
				projectId: "",
				useCertificateNumber: "",
				cityCode: "",
				districtCode: "",
				provinceCode: "",
				liftLocation: "",
				orderNo: "",
				startCreateTime: "",
				endCreateTime: "",
				createTimeBetween: null,
				signatureStatus: "",
				overdueStatus: "",
				locationStatus: "",
			},
			tableLoading: false,
			list: [],
			multipleSelection: [],
			pageIndex: 1,
			pageSize: 50,
			total: 0,
			checkOrder: false,
			orderDetail: {},
			unitList: [],
			projectList: [],
			addressWarn: false,
			showDetailAddress: false,
			addressName: "省市区",
			isSignList: [
				{
					code: 1,
					name: "是",
				},
				{
					code: 2,
					name: "否",
				},
			],
			payStatusList: [
				{
					code: 0,
					name: "免费",
				},
				{
					code: 1,
					name: "收费",
				},
			],
			departmentTree: [],
			propsTree: {
				multiple: true,
				value: "id",
				label: "departmentName",
				children: "childrenList",
				// checkStrictly: true
			},
			departmentIdList: [],
			showDesignate: false,
			designateRow: {},
			checkOrder2: false,
		};
	},
	computed: {
		hasRole: function () {
			return this.$store.getters["common/promise/getRole"](this.$route.path);
		},
		...mapState("common/dictionary", ["WXDZTDicts"]),
	},
	created() {
		this.getListData();
		this.getDepartmentTree();
	},
	methods: {
		async getDepartmentTree() {
			const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
			if (res.code === 200) {
				this.departmentTree = res.data;
			}
		},
		async getListData() {
			this.tableLoading = true;
			const params = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			};
			for (let key in this.form) {
				if (this.form[key]) params[key] = this.form[key];
			}
			if (this.form.createTimeBetween) {
				delete params.createTimeBetween;
				params.endCreateTime = this.form.createTimeBetween[1];
				params.startCreateTime = this.form.createTimeBetween[0];
			}
			const res = await getOrderList(params);
			if (res.code === 200) {
				this.total = res.data.total;
				this.list = res.data.list;
			}
			this.tableLoading = false;
		},
		handleSearch() {
			this.pageIndex = 1;
			this.getListData();
		},
		handleRefresh() {
			for (let key in this.form) {
				if (Array.isArray(this.form[key])) {
					this.form[key] = [];
				} else {
					this.form[key] = "";
				}
			}
			this.pageIndex = 1;
			this.getListData();
		},
		handleSearchListData() {
			this.pageIndex = 1;
			this.getListData();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleDeleteUnit(row) {
			const idList = [row.orderId];
			this.deleteOrder(idList);
		},
		handleZP(row) {
			this.designateRow = { ...row };
			this.showDesignate = true;
		},
		handleCheck(row) {
			console.log(row);
			this.orderDetail = row;

			if (row.orderType === 10) {
				this.checkOrder2 = true;
				return;
			}
			this.checkOrder = true;
		},
		handleDelete() {
			if (!this.multipleSelection.length) {
				this.$message.warning("请选择要删除的行");
				return;
			}
			const idList = this.multipleSelection.map((item) => item.orderId);
			this.deleteOrder(idList);
		},
		deleteOrder(idList) {
			this.$confirm("确定删除?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					const res = await deleteOrder({ idList });
					if (res.code === 200) {
						this.$message.success("删除成功");
						this.getListData();
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},

		designateConfirm() {
			this.getListData();
			this.showDesignate = false;
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getListData();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getListData();
		},
		async searchUnitList(keyword) {
			const res = await getPropertyUnitSimpleList({
				keyword: keyword,
				size: 1000,
			});
			if (res.code === 200) {
				this.unitList = res.data;
			}
		},
		async searchProjectList(keyword) {
			const res = await getProjectSimpleList({
				keyword: keyword,
				size: 1000,
			});
			if (res.code === 200) {
				this.projectList = res.data;
			}
		},
		setPojectAddress(data) {
			this.form.address = data.addressData; // 项目地址 详细地址
			this.form.provinceCode = data.provinceCode; // 项目地址省级 code
			this.form.provinceName = data.provinceName; // 项目地址省级 name
			this.form.cityCode = data.cityCode; // 项目地址城市 code
			this.form.cityName = data.cityName; // 项目地址城市 name
			this.form.districtCode = data.townCode; // 项目地址区级 code
			this.form.districtName = data.townName; // 项目地址区级 name
		},
		handleDepartment(val) {
			this.form.departmentIdList = [];
			const nodes = this.$refs.cascader.getCheckedNodes();
			nodes.forEach((item) => {
				this.form.departmentIdList.push(item.data.id);
			});
			this.handleSearchListData();
		},
	},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/AnnualInspection.vue